/** Presentation only: keep provider identifiers intact in transport and stored data. */
export function aiDisplayText(value: string): string {
  return value.replace(/通义千问|千问|\bqwen(?:[\w.-]*)\b|\bcodex\b/gi, "AI");
}

export function customerHealthDetail(value: string): string {
  return aiDisplayText(value).replace(
    "有任务已安全暂停，请打开待处理事项查看具体手机和原因。",
    "有设备或任务需要处理，请打开待处理事项查看具体原因。",
  );
}
